module.exports = __webpack_public_path__ + "img/bg-about.c24a7ee7.svg";